export default __webpack_public_path__ + "static/PPNeueMontreal-Medium-a850f831d8ad452baa579a5c87b6a6f5.woff";